import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Application/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error("Failed to find the root element. Check your index.html");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
